module.exports = __webpack_public_path__ + "static/media/agileciclogo.6f6e6e7b.png";